<div class="col-12 col-md-12 mt-2">
  <div class="menu-options">
    <div class="main-title">
      <i class="fa fa-mobile-phone"></i>
      <span> {{"Devices" | translate}}</span>
      <a class="pull-right btn btn-sm">
        <i class="fa fa-question-circle fa-fw" title="Group information for the devices is available here."></i>
      </a>
    </div>
    <div class="row mt-5" style="width: 100%;">
      <div class="col-7 col-md-7">
        <app-pagination [totalItems]="devices.length" [itemsPerPage]="devicePageSize" [itemsSearch]="search"
          (searchedData)="onSearch($event)" (itemPerPageData)="onItemPerPageChange($event)"
          (nextPageChange)="onNextPageChange($event)">
        </app-pagination>
      </div>

      <div class="col-5 col-md-5">
        <!-- <button class="btn btn btn-light remove-filter" (click)="showFilters = !showFilters"
        title="Filters for removing devices"><span class="fa fa-filter"></span>&nbsp; Filters</button> -->

        <!-- <button class="btn btn-success confirm-remove" (click)="confirmRemove.value = !confirmRemove.value"
        title="Enable/Disable confirmation for device removing"><span *ngIf="confirmRemove.value"
        class="fa fa-lock"></span><span *ngIf="!confirmRemove.value" class="fa fa-unlock"></span>&nbsp;
      Confirm Remove</button> -->
        <button class="btn btn-danger remove"
          (click)="removeDevices(search, filteredDevices, confirmRemove.value, delete_all_devices)"
          title="Remove the device selection"><span class="fa fa-regular fa-trash-o"></span>&nbsp; {{"Remove
          All" | translate}}</button>
      </div>
    </div>
  </div>

  <div class="col-12 col-md-12 device-table">

    <!-- <div class="row filter-section d-flex" *ngIf="showFilters">
  <div class="heading">
    <button class="btn btn-danger btn-sm" (click)="removeFilters()" style="margin: 1em;">
      <i class="fa fa-trash-o"></i>
      <span>Removing filters</span>
    </button>
  </div>
  <div class="col-md-2">
    <label title="Device Presence State"><span class="text-danger">*</span>Present</label>&nbsp;
    <select aria-hidden="true" [(ngModel)]="removingFilters.present">
      <option *ngFor="let option of removingFilterOptions" value="{{option}}">{{option}}</option>
    </select>
  </div>
  <div class="col-md-2">
    <label title="Device Booking State"><span class="text-danger">*</span>Booked</label>&nbsp;
    <select aria-hidden="true" [(ngModel)]="removingFilters.booked">
      <option *ngFor="let option of removingFilterOptions" value="{{option}}">{{option}}</option>
    </select>
  </div>
  <div class="col-md-2">
    <label title="Device Notes State"><span class="text-danger">*</span>Annotated</label>&nbsp;
    <select aria-hidden="true" [(ngModel)]="removingFilters.annotated">
      <option *ngFor="let option of removingFilterOptions" value="{{option}}">{{option}}</option>
    </select>
  </div>
  <div class="col-md-2">
    <label title="Device Controlling State"><span class="text-danger">*</span>Controlled</label>&nbsp;
    <select aria-hidden="true" [(ngModel)]="removingFilters.controlled">
      <option *ngFor="let option of removingFilterOptions" value="{{option}}">{{option}}</option>
    </select>
  </div>
</div> -->

    @for (device of devices | search: search | paginate: { itemsPerPage: devicePageSize, currentPage: page } ; track
    device; let i = $index) {
    <li class="list-group-item">
      <hr>
      <div class="device-line device-actions d-flex">
        <i class="fa fa-mobile fa-2x fa-fw device-list-icon"></i>
        <div class="device-list-details selectable">
          <div class="device-list-name">{{ device.model }}</div>
          <div class="device-list-id">
            <span>{{"Serial" | translate}}</span>
            <span>{{ ':: ' + device.serial + ' - ' }}</span>
            <span>{{"Manufacturer" | translate}}</span>
            <span>{{ ': ' + device.manufacturer }}</span>
            <span>{{"Market Name" | translate}}</span>
            <span>{{ ': ' + device.marketName }}</span>
            <span>{{"OS" | translate}}</span>
            <span>{{ ': ' + device.version + ' - ' }}</span>
            <br>
            <span>{{"Screen" | translate}}</span>
            <span>{{ ': ' + device.displayStr + ' - ' }}</span>
            <span>SDK</span>
            <span>{{ ': ' + device.sdk + ' - ' }}</span>
            <span>{{"Location" | translate}}</span>
            <span>{{ ': ' + device.provider.name + ' - ' }}</span>
            <span>{{"Group Origin" | translate}}</span>
            <span>{{ ': ' + device.group.originName }}</span>
          </div>
          <button class="btn btn-outline-danger remove pull-right" type="button"
            (click)="remove(device.serial, delete_devices)">
            <i class="fa fa-trash-o"></i>
            <span>&nbsp; {{"Remove" | translate}}</span>
          </button>
        </div>
      </div>
    </li>
    }
  </div>

</div>

<!-- Template -->
<ng-template #alert_message let-modal>
  <div class="modal-body text-center">
    <p class="alert-message" style="overflow-wrap: break-word;">{{alertMessage | translate}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-primary" (click)="cancelRequest()">{{"OK" | translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>

<ng-template #delete_all_devices let-modal>
  <div class="modal-body text-center">
    <p class="alert-message">{{"Are you sure you want to delete this selection of devices?" | translate}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-success" (click)="removeDevices();">{{"Yes, Proceed" |
        translate}}</button>&nbsp;
      <button type="button" class="btn btn-danger" (click)="cancelRequest()">{{"No, Cancel" |
        translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>

<ng-template #delete_devices let-modal>
  <div class="modal-body text-center">
    <p class="alert-message">{{"Are you sure you want to delete this device?" | translate}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-success" (click)="removeDevice();">{{"Yes, Proceed" |
        translate}}</button>&nbsp;
      <button type="button" class="btn btn-danger" (click)="cancelRequest()">{{"No, Cancel" |
        translate}}</button>&nbsp;
    </div>
  </div>
</ng-template>